import type { ApiResponse } from '@/stores/auth'
import { isDemoDeployment } from '@/utils/deployment'
import { apiCall } from './axiosInstance'
import { deviceComponentApi as demoDeviceComponentApi } from './demo/deviceComponentApi'

export interface DeviceComponent {
	name: string
	id: number
	is_deleted: boolean
	tenant_id: string
}

const v3DeviceComponentApi = {
	getDeviceComponents: async (): Promise<ApiResponse<Omit<DeviceComponent, 'tenant_id'>[], 'results'>> =>
		apiCall('/v3/device_components'), // Note: platform-ui used v1, but we map demo to v1 via adapter
	createDeviceComponent: async (component: Pick<DeviceComponent, 'name'>): Promise<DeviceComponent> =>
		apiCall('/v3/device_components', { method: 'POST', data: component }),
	updateDeviceComponent: async (
		componentId: number,
		component: Pick<DeviceComponent, 'name'>,
	): Promise<{ updated: boolean }> =>
		apiCall(`/v3/device_components/${encodeURIComponent(componentId)}`, {
			method: 'PUT',
			data: component,
		}),
	deleteDeviceComponent: async (componentId: number): Promise<{ deleted: boolean }> =>
		apiCall(`/v3/device_components/${encodeURIComponent(componentId)}`, {
			method: 'DELETE',
		}),
}

export const deviceComponentApi = isDemoDeployment() ? demoDeviceComponentApi : v3DeviceComponentApi
